// removed by extract-text-webpack-plugin
module.exports = {"container1":"solution_container1_347-z","logoContainer":"solution_logoContainer_1gGwd","description":"solution_description_-rGnm","solutions":"solution_solutions_2uY9t","solution":"solution_solution_FCaWw","image":"solution_image_1CQNC","close":"solution_close_nVZwZ","shadow":"solution_shadow_2rics","modalContainer":"solution_modalContainer_3-ezN","contentContainer":"solution_contentContainer_1odH1","lato-title":"solution_lato-title_2yPqs lato-title","lato-subtitle":"solution_lato-subtitle_237fe lato-subtitle"};


//////////////////
// WEBPACK FOOTER
// ./src/static/home/solutions/solution.css
// module id = 432
// module chunks = 4